import { Vue, Options } from 'vue-class-component';

@Options({
  name: 'ConfirmPlantUpdated',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    isVisible: function (newValue) {
      this.isDialogVisible = newValue;
    },
  },
  emits: ['hide-dialog'],
})
export default class ConfirmPlantUpdated extends Vue {
  isVisible!: boolean;
  isDialogVisible = false;

  mounted() {
    this.isDialogVisible = this.isVisible;
  }

  handleHideDialog() {
    this.isDialogVisible = false;
  }

  doHideDialog() {
    this.$emit('hide-dialog');
  }
}
